import dealer from "./dealer"
import ip from './ip'

export default app => {
  const v = app.config.globalProperties
  return {
    ...dealer(app),
    ...ip(app),
    getUserMe: function () {
      return v.$http({
        method: 'get',
        headers: {'Authorization': 'Bearer ' + v.$auth.getAccessToken()},
        baseURL: v.$env.getAPIPrefixV1_1(),
        url: '/users/me',
        responseType: 'json',
        timeout: 1000 * 5,
      })
    },
  }
}
